import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a2d367c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "breadcrumb-nav"
}
const _hoisted_2 = { class: "breadcrumb m-0" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}


export default /*#__PURE__*/_defineComponent({
  ...{
  name: "BreadcrumbNav",
},
  __name: 'BreadcrumbNav',
  props: {
    backLink: {},
    backText: {},
    currentPage: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, { to: _ctx.backLink }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.backText), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", _hoisted_4, _toDisplayString(_ctx.currentPage), 1)
    ])
  ]))
}
}

})